<template lang="pug">
div
  h1 Carregando
</template>
<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue2-helpers/vue-router'
import CustomerService from '@/services/CustomerService'

const router = useRouter()

onMounted(() => {
  window.addEventListener("message", async (event) => {
    try {
      const eventData = JSON.parse(event.data)

      if (eventData.event != 'appContext')  return

      console.debug('Message from Chatwoot', eventData)

      const data = eventData.data

      const customerEmail = data.contact?.email
      const customerPhone = data.contact?.phone_number
      const customerName = data.contact?.name

      const query = customerEmail ?? customerPhone

      const searchResult = query ? (await CustomerService.search({ query, pageSize: 1 })) : null

      if (searchResult?.count > 0 && (searchResult?.results[0]?.email == customerEmail || searchResult?.results[0]?.phoneNumber == customerPhone)) {
        router.push({ name: 'customer-detail', params: { 'id': searchResult.results[0].id }})
      } else {
        router.push({ name: 'customer-list', query: { 'search': customerName } })
      }
    } catch (e) {
      console.error(e);
    }
  })

  window.parent.postMessage('chatwoot-dashboard-app:fetch-info', '*')
})
</script>
